export default function ExcellenceSection() {
  const practices = [
    {
      title: 'Scalable Systems',
      description:
        'Architectures designed to grow gracefully, handling increasing complexity without compromising stability or developer velocity.',
      image:
        'https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20representing%20modular%20structured%20architecture%2C%20clean%20overlapping%20shapes%20in%20warm%20amber%20and%20terracotta%20tones%2C%20minimal%20modern%20design%2C%20soft%20gradient%20background%2C%20no%20text%2C%20no%20people%2C%20elegant%20engineering%20aesthetic%2C%20balanced%20composition&width=500&height=500&seq=card-arch-2026&orientation=squarish',
      imageAlt: 'Abstract modular architecture composition',
    },
    {
      title: 'High Performance',
      description:
        'Relentless attention to runtime efficiency, memory management, and rendering optimisation for fluid, responsive software.',
      image:
        'https://readdy.ai/api/search-image?query=Abstract%20dynamic%20composition%20suggesting%20speed%20and%20efficiency%2C%20flowing%20lines%20and%20gradients%20in%20warm%20gold%20and%20copper%20tones%2C%20minimal%20modern%20design%2C%20soft%20background%2C%20no%20text%2C%20no%20people%2C%20elegant%20engineering%20aesthetic&width=500&height=500&seq=card-perf-2026&orientation=squarish',
      imageAlt: 'Abstract performance and efficiency composition',
    },
    {
      title: 'Usability First',
      description:
        'Interfaces shaped by user research and iterative refinement, ensuring every interaction feels natural and purposeful.',
      image:
        'https://readdy.ai/api/search-image?query=Abstract%20minimal%20composition%20with%20smooth%20rounded%20forms%20and%20soft%20curves%20in%20warm%20rose%20and%20terracotta%20tones%2C%20elegant%20balance%20and%20harmony%2C%20clean%20gradient%20background%2C%20no%20text%2C%20no%20people%2C%20modern%20aesthetic&width=500&height=500&seq=card-ux-2026&orientation=squarish',
      imageAlt: 'Abstract usability and design composition',
    },
    {
      title: 'Technical Excellence',
      description:
        'Adoption of up-to-date engineering standards, continuous improvement of workflows, and rigorous quality practices throughout development.',
      image:
        'https://readdy.ai/api/search-image?query=Abstract%20precision%20geometric%20pattern%20with%20sharp%20clean%20lines%20and%20structured%20grid%2C%20warm%20amber%20and%20gold%20tones%2C%20minimal%20modern%20design%2C%20soft%20gradient%20background%2C%20no%20text%2C%20no%20people%2C%20elegant%20engineering%20precision%20aesthetic&width=500&height=500&seq=card-tech-2026&orientation=squarish',
      imageAlt: 'Abstract technical precision composition',
    },
  ];

  return (
    <section className="w-full bg-background-100 py-16 md:py-24 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-3">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
              Engineering
            </h2>
            <span className="text-3xl md:text-4xl lg:text-5xl font-bold text-accent-500">
              Excellence
            </span>
          </div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl">
            The principles and practices that guide every project we undertake,
            ensuring consistent quality and meaningful outcomes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {practices.map((item) => (
            <article
              key={item.title}
              className="bg-background-50 rounded-lg overflow-hidden group"
            >
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  title={item.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}